import { render, staticRenderFns } from "./DemoAutocompleteAutoSelectFirst.vue?vue&type=template&id=0590fa36&"
import script from "./DemoAutocompleteAutoSelectFirst.vue?vue&type=script&lang=js&"
export * from "./DemoAutocompleteAutoSelectFirst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
